/* eslint-disable */


import CategoryApi from "@shared/_api/category";
import {
    FETCH_ARTICLE_COLORS_SUCCESS, FETCH_ARTICLE_SIZES_SUCCESS, FETCH_ARTICLE_SUCCESS,
    FETCH_CATEGORY_ALL_SUCCESS,
    FETCH_CATEGORY_ARTICLE_LIST_SUCCESS, FETCH_CATEGORY_REQUEST,
    FETCH_CATEGORY_SUCCESS, FETCH_CUSTOMER_SHOPS_SUCCESS,
    FETCH_USER_SUCCESS, SET_SELECTED_COLOR, SET_SELECTED_SIZE
} from "../mutationTypes";
import ArticleApi from "@shared/_api/article";

const state = {
    categories: [],
    customerShops: [],
    selectedCategory: null,
    loadingCategory: false,
};

const actions = {
    fetchAllCategories({commit}) {
        CategoryApi.all().then(categories => commit(FETCH_CATEGORY_ALL_SUCCESS, categories))
            .catch(error => {
                console.log(error)
            })
    },
    fetchCategoryById({commit}, {id}) {
        commit(FETCH_CATEGORY_REQUEST);
        CategoryApi.byId(id).then(category => {
            commit(FETCH_CATEGORY_SUCCESS, category);
        }).catch(error => {
            console.log(error)
        })
    },
    fetchCustomerCategoryById({commit}, {id}) {
        commit(FETCH_CATEGORY_REQUEST);
        CategoryApi.customerCategoryById(id).then(category => commit(FETCH_CATEGORY_SUCCESS, category))
            .catch(error => {
                console.log(error)
            })
    },
    setArticleDetails({commit}, {article}) {
        return ArticleApi.byId(article.id).then(articleDetails => {
            commit(FETCH_ARTICLE_SUCCESS, articleDetails);
        }).catch(error => {
            console.log(error)
        })
    },
    setSelectedArticleSize({commit}, {articleId, articleSizeId}) {
        commit(SET_SELECTED_SIZE, {articleId, articleSizeId});
    },
    setSelectedArticleColor({commit}, {article, articleColor}) {
        commit(SET_SELECTED_COLOR, article, articleColor);
    }

};


const getters = {
    customerCategory: state => {
        let selectedCategory = state.selectedCategory;
        selectedCategory.articleList = selectedCategory.articleList.map(article => {
            if(article.articleDetails) {
                let colorOptions = [];
                let sizeOptions = [];

                let map = new Map();
                for (const item of article.articleDetails.variantList) {
                    if (!map.has(item.articleSize.id)) {
                        map.set(item.articleSize.id, true);
                        sizeOptions.push({
                            value: item.articleSize.id,
                            text: item.articleSize.value
                        });
                    }
                }
                map = new Map();
                for (const item of article.articleDetails.variantList) {
                    if (!map.has(item.articleColor.id)) {
                        map.set(item.articleColor.id, true);
                        colorOptions.push({
                            value: item.articleColor.id,
                            text: item.articleColor.value
                        });
                    }
                }
                article.colorOptions = colorOptions;
                article.sizeOptions = sizeOptions;
            }

            return article;
        });
        return selectedCategory;
    }
};


const mutations = {
    [FETCH_CATEGORY_ALL_SUCCESS](state, categories) {
        state.categories = categories;
    },
    [FETCH_CATEGORY_REQUEST](state) {
        state.loadingCategory = true;
    },
    [FETCH_CATEGORY_SUCCESS](state, category) {
        state.selectedCategory = category;
        state.loadingCategory = false;
    },
    [FETCH_ARTICLE_SUCCESS](state, articleDetails) {
        let index = state.selectedCategory.articleList.findIndex(article => Number(article.id) === Number(articleDetails.id));
        Vue.set(state.selectedCategory.articleList[index], 'articleDetails', articleDetails);
    },
    [FETCH_ARTICLE_COLORS_SUCCESS](state, {colors, articleId}) {
        let article = state.selectedCategory.articleList.find(a => Number(a.id) === Number(articleId));
        article.colors = colors.map(c => {
            return {value: c.id, text: c.value}
        });
        let index = state.selectedCategory.articleList.findIndex(a => Number(a.id) === Number(articleId));
        state.selectedCategory.articleList = {
            ...state.selectedCategory.articleList,
            [state.selectedCategory.articleList[index].colors]: colors,
        }

    },
    [FETCH_ARTICLE_SIZES_SUCCESS](state, sizes, articleId) {
        let article = state.selectedCategory.articleList.find(a => Number(a.id) === Number(articleId));
        article.sizes = sizes;
    },
    [SET_SELECTED_COLOR](state, {articleId, articleColor}) {

    },
    [SET_SELECTED_SIZE](state, {articleId, articleSizeId}) {
        let index = state.selectedCategory.articleList.findIndex(article => Number(article.id) === Number(articleId));
        Vue.set(state.selectedCategory.articleList[index], 'selectedSize', articleSizeId);
    },

};

export const categoryManagement = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};